import { Navigate, Outlet } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import { useAuthStore } from '../stores/StoreProvider';

export const ProtectedRoute = observer(function ProtectedRoute() {
  const authStore = useAuthStore();

  if (!authStore.isLoggedIn) {
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
});